"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
const tslib_1 = require("tslib");
const browser_1 = tslib_1.__importDefault(require("@sm/apollo-clients/dist/browser"));
const getFragmentMatcherGenerator_1 = tslib_1.__importDefault(require("./getFragmentMatcherGenerator"));
/**
 * Gets an Apollo client for use in wrapping shared components.
 */
const getApolloClient = (graphQLClientConfig, fragmentTypes) => {
  if (!graphQLClientConfig.graphQLUri) {
    throw new Error('GraphQL Uri not provided');
  }
  const apolloClientProps = {
    uri: graphQLClientConfig.graphQLUri,
    cacheHydration: {},
    pageRequestId: graphQLClientConfig.pageRequestId,
    linkOptions: {
      credentials: 'include',
      batchInterval: 30
    },
    metadata: {
      appName: graphQLClientConfig.appName,
      appVersion: graphQLClientConfig.appVersion
    },
    availableLoggedOutPaths: []
  };
  if (fragmentTypes) {
    apolloClientProps.fragmentMatcherFn = (0, getFragmentMatcherGenerator_1.default)(fragmentTypes);
  }
  return (0, browser_1.default)(apolloClientProps);
};
exports.default = getApolloClient;